import { Auth0ProviderOptions } from "@auth0/auth0-react";
import { authCookieDomain } from "@cohesive/ui-components";
import { config } from "./config";
import { nativeCallbackUri } from "./native/auth";
import { isRealNativePlatform } from "./native/platform";

const native = isRealNativePlatform();

export const auth0Config: Auth0ProviderOptions = {
  domain: config.auth0.domain,
  clientId: config.auth0.clientId,
  cacheLocation: "localstorage",
  useRefreshTokens: true,
  // On native the hidden-iframe fallback can never succeed (no third-party
  // cookies in a custom-scheme webview), so disable it and rely on refresh tokens.
  useRefreshTokensFallback: !native,
  // Undefined off cohesive.ai, so this is inert on native (capacitor://localhost).
  cookieDomain: authCookieDomain(),
  authorizationParams: {
    // Native deep-links back via the custom scheme; web uses the page origin.
    redirect_uri: native ? nativeCallbackUri() : window.location.origin,
    audience: config.auth0.audience,
    ...(config.appEnv !== "prod"
      ? { cohesive_api_base_url: config.hosts.api }
      : {}),
  },
};
